import React from 'react';
import S2SBaseComponent from 's2s-base-class';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Utilities, track } from 's2s-app-service';
import {
    doUpdateSettings,
    doSubmitLogOut,
    doMedia,
    doSendConfCommand,
    doClearHistory,
    doDismissAlert,
    doClearAlerts,
    doToggleSettingsOpen,
    doKeepSettingsOpen
  }
from '../action-creators/index.js';
import { compose } from 'recompose';
import { IntlProvider } from 'react-intl';
import Theme from 's2s-themes';
import { BrowserRouter, Route, Switch, Redirect, withRouter } from "react-router-dom";
import { AppMain } from './index.js';
import { Update } from './index';
import LoggingService from 's2s-logging-service';
//import { doAppInitialize } from '../action-creators/index';

class Main extends S2SBaseComponent {
  constructor(props) {
    super(props);
    this.displayName = 'Main';
    this.state={};

    //this.props.dispatch(doAppInitialize(this.props.history));
    this.prefetchStyles();
  }

  shouldComponentUpdate(nextProps, nextState){
    return !fromJS(this.props).equals(fromJS(nextProps)) || !fromJS(this.state).equals(fromJS(nextState));
  }

  getDefaultStyle(styleName) {
    const styles = {
      vidWindowStyle : {
        alignItems: 'center',
        display: 'flex',
        flex:'1',
        flexDirection: 'column',
        height: '100vh',
        justifyContent: 'space-between',
        minWidth: '272px',
        overflow: 'hidden',
        position: 'relative'
      }
    };

    return (styles[styleName]);
  }

  prefetchStyles () {
    this.vidWindowStyle = this.getStyle("vidWindowStyle");
  }

  render() {

    LoggingService.getInstance().debug('MainRoute');

    return (
      <IntlProvider key = {this.props.localeData} locale={this.props.localeData.locale} messages={this.props.localeData.messages}>
        <Theme key={this.props.uiTheme.appliedThemeName} appliedStyle={this.props.uiTheme.appliedTheme}  >
          <div className = 'Main' style = {this.vidWindowStyle}>
          <BrowserRouter>
            <Switch>
              <Route path="/appmain" component={AppMain}/>
              <Route path="/update" component={Update}/>
              <Redirect from="/" exact to="/appmain/login" />
            </Switch>
          </BrowserRouter>
          </div>
        </Theme>
      </IntlProvider>
    );
  }
}

const hocComponent = compose(connect((state)=>{
    //LoggingService.getInstance().debug('MAIN STORE: ', state);
    return ({
      uiTheme : state.app.uiTheme, // Possible TODO: Create Selectors getTheme()
      localeData : state.app.localeData // Possible TODO: Create Selector getLocaleData()
    });
  }), withRouter
);

export default hocComponent(Main);



// WEBPACK FOOTER //
// ./src/routes/main.js